import React from "react";
import SectionHeader from "../../Components/SectionHeader/SectionHeader";
import { useState } from "react";
import InputDescription from "../../Components/SiteComponants/FormElements/InputDescription";
import { useRef } from "react";
import { noticeAlert } from "../../Datas/SiteData/AllinOne";
import { useEffect } from "react";
import SpecialButton from "../../Components/SiteComponants/SpecialButton";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import { TitleSetup } from "../../Datas/Functions/titleSetup";

const ManageNotice = (meta) => {
  TitleSetup({...meta});
  const [notice, setNotice] = useState(noticeAlert);
  const noticeRef = useRef(null);
  useEffect(() => {
    noticeRef.current.innerHTML = notice;
  }, [notice]);
  return (
    <div className="container">
      <SectionHeader heading={"Notice Management"} className={"text-center"} />
      <BreadCrumbs texts={["Dashboard", "Manage Notice"]} />
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 my-10 ">
        <div className="mx-auto col-span-1">
          <div className="box p-5 rounded border box">
            <InputDescription
              title={"Notice Board"}
              value={notice}
              setValue={setNotice}
              className={`border  placeholder:dark:text-white w-full`}
              placeholder="Write your Notice . . . "
            />
            <div className="text-center my-3">
              <SpecialButton text="Submit" />
            </div>
          </div>
        </div>
        <div className="mx-auto col-span-1 box">
          <h2 className="font-bold text-xl text-center my-3">Preview </h2>
          <div
            className="w-full description-output dark:dark-bg-front bg-front mb-4  p-10 text-base text-primary-600  relative pl-10"
            role="alert"
            ref={noticeRef}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ManageNotice;
